import { reactive, ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4357af2e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "order-detail"
};
const _hoisted_2 = {
  class: "order-detail-content"
};
const _hoisted_3 = {
  class: "detail-row"
};
const _hoisted_4 = {
  class: "detail-item"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "内购ID:", -1));
const _hoisted_6 = {
  class: "value"
};
const _hoisted_7 = {
  class: "detail-row"
};
const _hoisted_8 = {
  class: "detail-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "用户UID:", -1));
const _hoisted_10 = {
  class: "value"
};
const _hoisted_11 = {
  class: "detail-row"
};
const _hoisted_12 = {
  class: "detail-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "支付渠道:", -1));
const _hoisted_14 = {
  class: "value"
};
const _hoisted_15 = {
  class: "detail-row"
};
const _hoisted_16 = {
  class: "detail-item"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "设备型号:", -1));
const _hoisted_18 = {
  class: "value"
};
const _hoisted_19 = {
  class: "detail-row"
};
const _hoisted_20 = {
  class: "detail-item"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "应用版本:", -1));
const _hoisted_22 = {
  class: "value"
};
const _hoisted_23 = {
  class: "detail-row"
};
const _hoisted_24 = {
  class: "detail-item"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "操作系统:", -1));
const _hoisted_26 = {
  class: "value"
};
const _hoisted_27 = {
  class: "detail-row"
};
const _hoisted_28 = {
  class: "detail-item"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "道具下发时间:", -1));
const _hoisted_30 = {
  class: "value"
};
const _hoisted_31 = {
  class: "detail-row"
};
const _hoisted_32 = {
  class: "detail-item"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "失败原因:", -1));
const _hoisted_34 = {
  class: "value"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetail',
  setup(__props, {
    expose
  }) {
    const orderInfo = reactive({
      prodId: '',
      payChnl: '',
      userId: '',
      appVer: '',
      os: '',
      model: '',
      lastShipTime: '',
      failResult: ''
    });
    const visible = ref(false);
    // 关闭弹窗
    const handleClose = () => {
      visible.value = false;
    };
    // 打开弹窗并设置数据
    const open = data => {
      orderInfo.prodId = data.prodId || '-';
      orderInfo.payChnl = data.payChnl || '-';
      orderInfo.userId = data.userId || '-';
      orderInfo.appVer = data.appVer || '-';
      orderInfo.os = data.os || '';
      orderInfo.model = data.model || '-';
      orderInfo.lastShipTime = data.lastShipTime || '-';
      orderInfo.failResult = data.failResult || '-';
      visible.value = true;
    };
    expose({
      open
    });
    return (_ctx, _cache) => {
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => visible.value = $event),
        footer: null,
        width: 840,
        onCancel: handleClose,
        centered: "",
        title: "订单详情"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", _hoisted_6, _toDisplayString(orderInfo.prodId), 1)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", _hoisted_10, _toDisplayString(orderInfo.userId), 1)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(orderInfo.payChnl), 1)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(orderInfo.model), 1)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("span", _hoisted_22, _toDisplayString(orderInfo.appVer), 1)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("span", _hoisted_26, _toDisplayString(orderInfo.os ? orderInfo.os == '1' ? '安卓' : '苹果' : '-'), 1)])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("span", _hoisted_30, _toDisplayString(orderInfo.lastShipTime), 1)])]), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_hoisted_33, _createElementVNode("span", _hoisted_34, _toDisplayString(orderInfo.failResult), 1)])])])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});